import Vue from 'vue';

import Modal from "./components/Modal";
import ModalQuestion from "./components/Modal.question";
import Popup from "./components/Popup";

import Login from "./components/account/Login";
import Logout from "./components/account/Logout";

import MoneyCheckbox from "./components/MoneyCheckbox";
import MonthsCheckbox from "./components/MonthsCheckbox";

import PeriodEdit from "./components/Period.edit";
import OvertimeEdit from "./components/Overtime.edit";
import ExpenseEdit from "./components/Expense.edit";
import SalaryEdit from "./components/Salary.edit";
import Wish from './components/Wish';
import WishEdit from './components/Wish.edit';

import Salary from "./components/Salary";
import Salaries from "./components/Salaries";
import Expense from "./components/Expense";
import Expenses from "./components/Expenses";
import Overtime from "./components/Overtime";
import User from "./components/User";
import Summary from "./components/Summary";
import ToPaid from "./components/ToPaid";
import Colorex from "./components/Colorex";
import Spinner from './components/Spinner';

Vue.component("Modal", Modal);
Vue.component("ModalQuestion", ModalQuestion);
Vue.component("Popup", Popup);

Vue.component("Login", Login);
Vue.component("Logout", Logout);

Vue.component("MoneyCheckbox", MoneyCheckbox);
Vue.component("MonthsCheckbox", MonthsCheckbox);

Vue.component("PeriodEdit", PeriodEdit);
Vue.component("OvertimeEdit", OvertimeEdit);
Vue.component("ExpenseEdit", ExpenseEdit);
Vue.component("SalaryEdit", SalaryEdit);
Vue.component("Wish", Wish);
Vue.component("WishEdit", WishEdit);

Vue.component("Salary", Salary);
Vue.component("Salaries", Salaries);
Vue.component("Expense", Expense);
Vue.component("Expenses", Expenses);
Vue.component("Overtime", Overtime);
Vue.component("User", User);
Vue.component("Summary", Summary);
Vue.component("ToPaid", ToPaid);
Vue.component("Colorex", Colorex);
Vue.component("Spinner", Spinner);